import React from 'react'

const Title = () => {
    return (
        <div className="App">
            <h2 className='TitleText'>OVERVIEW</h2>
        </div>
    );
};

export default Title;